import { useState } from "react";
import { scrollToId } from "@/lib/lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Products from "@/components/Products";
import RoiCalculator from "@/components/RoiCalculator";
import Designer from "@/components/Designer";
import WhyUs from "@/components/WhyUs";
import Process from "@/components/Process";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  const [product, setProduct] = useState("");
  const [designMsg, setDesignMsg] = useState("");

  const handleEnquire = (p) => {
    setProduct(p);
    setTimeout(() => scrollToId("quote"), 60);
  };

  const handleDesign = (msg) => {
    setProduct("Complete Rooftop System");
    setDesignMsg(msg);
    setTimeout(() => scrollToId("quote"), 60);
  };

  return (
    <div className="min-h-screen bg-obsidian text-warm antialiased" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Products onEnquire={handleEnquire} />
        <RoiCalculator />
        <Designer onQuote={handleDesign} />
        <WhyUs />
        <Process />
        <QuoteForm preselected={product} designMessage={designMsg} />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
